// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Bloomberg Terminal';

interface TerminalProps {
  className?: string;
}

export function TerminalWhite({ className }: TerminalProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-label={TITLE}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>{TITLE}</title>
      <path
        d="M9.52381 14.3579V14.8212C9.52381 15.0842 9.73701 15.2974 10 15.2974C10.263 15.2974 10.4762 15.0842 10.4762 14.8212V14.3579C12.3554 14.4604 13.8095 15.1618 13.8095 16.0118C13.8095 16.9323 12.1039 17.6786 10 17.6786C7.89606 17.6786 6.19048 16.9323 6.19048 16.0118C6.19048 15.1618 7.64461 14.4604 9.52381 14.3579ZM6.90476 16.0118C6.90476 16.037 6.92741 16.0854 7.00338 16.164C7.12375 16.2886 7.3248 16.4188 7.59256 16.5359C8.2064 16.8045 9.06949 16.9642 10 16.9642C10.9305 16.9642 11.7936 16.8045 12.4074 16.5359C12.6752 16.4188 12.8763 16.2886 12.9966 16.164C13.0726 16.0854 13.0952 16.037 13.0952 16.0118C13.0952 15.7483 12.3174 15.3236 11.1462 15.1441C11.0054 15.6447 10.5456 16.0118 10 16.0118C9.45443 16.0118 8.99458 15.6447 8.85384 15.1441C7.68255 15.3236 6.90476 15.7483 6.90476 16.0118ZM0.952381 4.82141H8.57143C9.09741 4.82141 9.52381 5.24781 9.52381 5.77379V12.4607C9.52381 12.9866 9.09741 13.413 8.57143 13.413H0.952381C0.426395 13.413 0 12.9866 0 12.4607V5.77379C0 5.24781 0.426395 4.82141 0.952381 4.82141ZM0.952381 5.77604V12.4584H8.57143V5.77604H0.952381ZM11.4286 4.82141H19.0476C19.5736 4.82141 20 5.24781 20 5.77379V12.4607C20 12.9866 19.5736 13.413 19.0476 13.413H11.4286C10.9026 13.413 10.4762 12.9866 10.4762 12.4607V5.77379C10.4762 5.24781 10.9026 4.82141 11.4286 4.82141ZM11.4286 5.77604V12.4584H19.0476V5.77604H11.4286Z"
        fill="currentColor"
      />
    </svg>
  );
}
